export const SITE_URL = "https://www.partograd.com";
export const SITE_NAME = "رادیولوژی پرتوگراد";
export const DEFAULT_TITLE = "رادیولوژی فک و صورت و سی تی اسکن دندان در شهر قدس";
export const DEFAULT_DESCRIPTION =
    "مرکز تخصصی رادیولوژی دهان، فک و صورت پرتوگراد در شهر قدس؛ سی تی اسکن دندان (CBCT)، او پی جی (OPG)، " +
    "عکس تخصصی دندان و فوتوگرافی ارتودنسی با کمترین دوز اشعه و پوشش بیمه.";
export const DEFAULT_IMAGE = SITE_URL + "/img/icons/android-chrome-512x512.png";

// Must stay in sync with SeoHelper.Slugify in the API so canonical URLs match sitemap.xml.
export function slugify (text) {
  if (!text) {
    return "";
  }
  return String(text).trim()
      .replace(/[^\p{L}\p{N}\p{M}‌]+/gu, "-")
      .replace(/^[-‌]+|[-‌]+$/g, "")
      .toLowerCase();
}

function detailPath (section, id, title) {
  const slug = slugify(title);
  return slug ? `/${section}/${id}/${slug}` : `/${section}/${id}`;
}

export const paths = {
  blogPost: (post) => detailPath("BlogPostsDetails", post.id, post.title),
  product: (product) => detailPath("ServiceDetails2", product.id, product.productName),
  service: (service) => detailPath("ServiceDetails", service.id, service.productName),
};

// Old links (raw titles, other letter case) are swapped for the canonical URL once the item has loaded.
export function replaceWithCanonicalPath (vm, path) {
  let current = vm.$route.path;
  try {
    current = decodeURI(current);
  } catch (e) {
    // malformed escape sequence: compare the raw path
  }
  if (current !== path) {
    vm.$router.replace(path).catch(() => {});
  }
}

export function absoluteUrl (path) {
  return SITE_URL + encodeURI(path);
}

export function toHttps (url) {
  return url ? url.replace("http://", "https://") : url;
}

export function stripHtml (html, maxLength = 160) {
  if (!html) {
    return "";
  }
  const doc = new DOMParser().parseFromString(html, "text/html");
  const text = (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  if (text.length <= maxLength) {
    return text;
  }
  const cut = text.lastIndexOf(" ", maxLength);
  return text.substring(0, cut > 0 ? cut : maxLength) + "…";
}

// CMS article bodies start with their own <h1>; the page already renders the title as <h1>.
export function demoteHeadings (html) {
  return html ? html.replace(/<(\/?)h1(?=[\s>])/gi, "<$1h2") : html;
}

export function breadcrumbJsonLd (items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

/**
 * vue-meta object for a page. `title` is wrapped by the titleTemplate in App.vue.
 */
export function pageMeta ({title, description, path, image, type = "website", keywords, noindex = false, jsonLd = []}) {
  const desc = description || DEFAULT_DESCRIPTION;
  const img = toHttps(image) || DEFAULT_IMAGE;
  const url = path ? absoluteUrl(path) : null;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${DEFAULT_TITLE} | ${SITE_NAME}`;

  const meta = [
    {vmid: "description", name: "description", content: desc},
    {vmid: "robots", name: "robots", content: noindex ? "noindex, follow" : "index, follow, max-image-preview:large"},
    {vmid: "og:title", property: "og:title", content: fullTitle},
    {vmid: "og:description", property: "og:description", content: desc},
    {vmid: "og:type", property: "og:type", content: type},
    {vmid: "og:image", property: "og:image", content: img},
    {vmid: "twitter:card", name: "twitter:card", content: "summary_large_image"},
    {vmid: "twitter:title", name: "twitter:title", content: fullTitle},
    {vmid: "twitter:description", name: "twitter:description", content: desc},
    {vmid: "twitter:image", name: "twitter:image", content: img},
  ];
  if (url) {
    meta.push({vmid: "og:url", property: "og:url", content: url});
  }
  if (keywords) {
    meta.push({vmid: "keywords", name: "keywords", content: keywords.trim().replace(/[,،\s]+$/, "")});
  }

  return {
    title: title || DEFAULT_TITLE,
    meta,
    link: url && !noindex ? [{vmid: "canonical", rel: "canonical", href: url}] : [],
    script: jsonLd.map((json, index) => ({vmid: `ld-json-${index}`, type: "application/ld+json", json})),
  };
}
